export const watch = {
  computedRows: function() {
    this.onUpdate({
      filtersData: this.filtersData
    })
  }
}
